import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, Button, Grid, IconButton, Toolbar, Typography } from "@mui/material";
import { useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { DRAWER_WIDTH, HEADER_HEIGHT, PRIMARY_COLOUR } from '../constants';
import { useACL } from '../hooks/useAuth';
import { USER_ACL } from '../types/types';
import ThemeToggle from './ThemeSwitch';
import { getStoredTheme, THEME_KEY } from '../App';


export enum HeaderActionType {
  LOGIN,
  WORKSPACE,
  ADMIN,
  DASHBOARD,
}

export type HeaderProps = {
  drawerOpen: boolean;
  activeActions: HeaderActionType[];
  isLoggedIn?: boolean;
};

export const Header = ({ drawerOpen, isLoggedIn, activeActions }: HeaderProps) => {
  const navigate = useNavigate();
  const { acl } = useACL();

  return (
    <Box>
      <AppBar
        position='fixed'
        sx={{
          height: HEADER_HEIGHT,
          backgroundColor: PRIMARY_COLOUR,
        }}

      >
        <Toolbar>
          <img
            src="/craneIconWhite.png"
            alt="Construction Yard Logo"
            style={{
              borderRadius: "0.25rem", // similar to 'ui rounded image'
              maxWidth: 80,
              height: HEADER_HEIGHT - 20,
              marginRight: 20,
            }}
          />
          <Typography color="text.primary" variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Construction Yard
          </Typography>
          {acl === USER_ACL.ADMIN && activeActions.includes(HeaderActionType.ADMIN) && (
            <Button
              onClick={() => {
                navigate("/admin");
              }}
              color="inherit"
            >
              Admin
            </Button>
          )}
          {isLoggedIn && activeActions.includes(HeaderActionType.DASHBOARD) && (
            <Button
              onClick={() => {
                navigate("/dashboard");
              }}
              color="inherit"
            >Scenes</Button>
          )}
          {activeActions.includes(HeaderActionType.WORKSPACE) &&
            (
              <Button
                onClick={() => {
                  navigate("/workspace");
                }}
                color="inherit"
              >Workspace</Button>
            )
          }
          {activeActions.includes(HeaderActionType.LOGIN) &&
            <>
              {!isLoggedIn && (
                <Button
                  onClick={() => {
                    navigate("/login");
                  }}
                  color="inherit"
                >Login</Button>
              )}
              {isLoggedIn && (
                <Button
                  onClick={() => {
                    localStorage.removeItem("jwt");
                    window.location.href = "/";
                  }}
                  color="inherit"
                >Logout</Button>
              )}
            </>}
          <ThemeToggle />
        </Toolbar>
      </AppBar>
    </Box>
  );
}
